import React, { useContext } from "react"
import { useFormContext } from "react-hook-form"

import Form from "src/components/Form"
import Heading from "src/components/Heading"
import InlineNotice from "src/components/InlineNotice"

import FormSection from "./FormSection"
import { ItemFormContext } from "./ItemFormContainer"
import { appliedTaxRate } from "./helpers"

// Whether QuickBooks receives this item's lines as TAX or NON. Collecting no tax is
// not the same as being non-taxable, which is why this is an explicit choice and not
// read off a 0% rate: fuel priced with tax baked into the per-gallon rate is taxable
// at 0%.
const Taxable = () => {
  const { useNewTaxExperience, marinaTaxes } = useContext(ItemFormContext)
  const { register, watch } = useFormContext()

  const [taxable, defaultTax, appliedTaxIds, productTaxesAttributes] = watch([
    "taxable",
    "defaultTax",
    "appliedTaxIds",
    "productTaxesAttributes",
  ])

  // Only ever asked as a yes/no. The two paths carry different units — the legacy
  // field is a percent, the itemized helper returns a fraction — so nothing here
  // should hold on to the number itself.
  const collectsTax = useNewTaxExperience
    ? appliedTaxRate({ marinaTaxes, appliedTaxIds, productTaxesAttributes }) > 0
    : Number(defaultTax) > 0

  return (
    <FormSection>
      <Heading.SectionHeader>Tax</Heading.SectionHeader>
      <Form.Checkbox {...register("taxable")} label="This item is taxable" />
      {!taxable && collectsTax && (
        <InlineNotice variant="warning" icon="fa-exclamation-circle">
          This item is marked not taxable but still has tax applied to it. Sales
          of this item will collect tax.
        </InlineNotice>
      )}
      {taxable && !collectsTax && (
        <InlineNotice icon="fa-info-circle">
          This item has no tax applied. Did you mean to set a tax rate, or to
          mark it not taxable?
        </InlineNotice>
      )}
    </FormSection>
  )
}

export default Taxable
